import { createApiSaga } from '../../../sagaGenerator';
import {
  apiGet, apiPost, apiPut,
} from '../../../../middleware/api';
import {
  GET_EDIT_DEPOSIT_REQUEST,
  GET_EDIT_DEPOSIT_SUCCESS,
  GET_EDIT_DEPOSIT_FAILURE,
  UPDATE_EDIT_DEPOSIT_REQUEST,
  UPDATE_EDIT_DEPOSIT_SUCCESS,
  UPDATE_EDIT_DEPOSIT_FAILURE,
  CREATE_EDIT_DEPOSIT_REQUEST,
  CREATE_EDIT_DEPOSIT_SUCCESS,
  CREATE_EDIT_DEPOSIT_FAILURE,
  EDIT_DEPOSIT_TSUNAMI_REQUEST,
  EDIT_DEPOSIT_TSUNAMI_SUCCESS,
  EDIT_DEPOSIT_TSUNAMI_FAILURE,
  EDIT_DEPOSIT_TSUNAMI_SEARCH_REQUEST,
  EDIT_DEPOSIT_TSUNAMI_SEARCH_SUCCESS,
  EDIT_DEPOSIT_TSUNAMI_SEARCH_FAILURE,
  EDIT_DEPOSIT_REFERENCE_REQUEST,
  EDIT_DEPOSIT_REFERENCE_SUCCESS,
  EDIT_DEPOSIT_REFERENCE_FAILURE,
  EDIT_DEPOSIT_REFERENCE_SEARCH_REQUEST,
  EDIT_DEPOSIT_REFERENCE_SEARCH_SUCCESS,
  EDIT_DEPOSIT_REFERENCE_SEARCH_FAILURE,
  EDIT_DEPOSIT_LOCATION_NAME_REQUEST,
  EDIT_DEPOSIT_LOCATION_NAME_FAILURE,
  EDIT_DEPOSIT_LOCATION_NAME_SUCCESS,
  EDIT_DEPOSIT_COUNTRY_REQUEST,
  EDIT_DEPOSIT_COUNTRY_FAILURE,
  EDIT_DEPOSIT_COUNTRY_SUCCESS,
  EDIT_DEPOSIT_PUBLICATIONS_FAILURE,
  EDIT_DEPOSIT_PUBLICATIONS_REQUEST,
  EDIT_DEPOSIT_PUBLICATIONS_SUCCESS,
  EDIT_DEPOSIT_EVENT_REQUEST,
  EDIT_DEPOSIT_BODY_OF_WATER_SUCCESS,
  EDIT_DEPOSIT_BODY_OF_WATER_FAILURE,
  EDIT_DEPOSIT_GEOLOGIC_AGE_FAILURE,
  EDIT_DEPOSIT_GEOLOGIC_AGE_SUCCESS,
  EDIT_DEPOSIT_GEOLOGIC_AGE_REQUEST,
  EDIT_DEPOSIT_EVENT_FAILURE,
  EDIT_DEPOSIT_BODY_OF_WATER_REQUEST,
  EDIT_DEPOSIT_EVENT_SUCCESS,
} from './depositEditReducer';


const getDepositSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/deposits/${action.id}`, ...action }),
  requestType: GET_EDIT_DEPOSIT_REQUEST,
  successType: GET_EDIT_DEPOSIT_SUCCESS,
  failureType: GET_EDIT_DEPOSIT_FAILURE,
});

const createDepositSaga = createApiSaga({
  apiFunction: apiPost,
  generateApiConfig: action => ({ endpoint: '/tsunamis/deposits', ...action }),
  requestType: CREATE_EDIT_DEPOSIT_REQUEST,
  successType: CREATE_EDIT_DEPOSIT_SUCCESS,
  failureType: CREATE_EDIT_DEPOSIT_FAILURE,
  successMessage: 'Saved',
});

const updateDepositSaga = createApiSaga({
  apiFunction: apiPut,
  generateApiConfig: action => ({ endpoint: `/tsunamis/deposits/${action.id}`, ...action }),
  requestType: UPDATE_EDIT_DEPOSIT_REQUEST,
  successType: UPDATE_EDIT_DEPOSIT_SUCCESS,
  failureType: UPDATE_EDIT_DEPOSIT_FAILURE,
  successMessage: 'Saved',
});

const getTsunamiSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/deposits/${action.id}/tsunamis`, ...action }),
  requestType: EDIT_DEPOSIT_TSUNAMI_REQUEST,
  successType: EDIT_DEPOSIT_TSUNAMI_SUCCESS,
  failureType: EDIT_DEPOSIT_TSUNAMI_FAILURE,
});

const searchTsunamisSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/tsunamis/events', ...action }),
  requestType: EDIT_DEPOSIT_TSUNAMI_SEARCH_REQUEST,
  successType: EDIT_DEPOSIT_TSUNAMI_SEARCH_SUCCESS,
  failureType: EDIT_DEPOSIT_TSUNAMI_SEARCH_FAILURE,
});

const getReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/deposits/${action.id}/references`, ...action }),
  requestType: EDIT_DEPOSIT_REFERENCE_REQUEST,
  successType: EDIT_DEPOSIT_REFERENCE_SUCCESS,
  failureType: EDIT_DEPOSIT_REFERENCE_FAILURE,
});

const searchReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/references', ...action }),
  requestType: EDIT_DEPOSIT_REFERENCE_SEARCH_REQUEST,
  successType: EDIT_DEPOSIT_REFERENCE_SEARCH_SUCCESS,
  failureType: EDIT_DEPOSIT_REFERENCE_SEARCH_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/countries', ...action }),
  requestType: EDIT_DEPOSIT_COUNTRY_REQUEST,
  successType: EDIT_DEPOSIT_COUNTRY_SUCCESS,
  failureType: EDIT_DEPOSIT_COUNTRY_FAILURE,
});

const getLocationNameSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/location-names', ...action }),
  requestType: EDIT_DEPOSIT_LOCATION_NAME_REQUEST,
  successType: EDIT_DEPOSIT_LOCATION_NAME_SUCCESS,
  failureType: EDIT_DEPOSIT_LOCATION_NAME_FAILURE,
});

const getPublicationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/publication-types', ...action }),
  requestType: EDIT_DEPOSIT_PUBLICATIONS_REQUEST,
  successType: EDIT_DEPOSIT_PUBLICATIONS_SUCCESS,
  failureType: EDIT_DEPOSIT_PUBLICATIONS_FAILURE,
});

const getEventSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/event', ...action }),
  requestType: EDIT_DEPOSIT_EVENT_REQUEST,
  successType: EDIT_DEPOSIT_EVENT_SUCCESS,
  failureType: EDIT_DEPOSIT_EVENT_FAILURE,
});

const getBodiesOfWaterSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/bodies-of-water', ...action }),
  requestType: EDIT_DEPOSIT_BODY_OF_WATER_REQUEST,
  successType: EDIT_DEPOSIT_BODY_OF_WATER_SUCCESS,
  failureType: EDIT_DEPOSIT_BODY_OF_WATER_FAILURE,
});

const getGeologicAgeSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/geologic-ages', ...action }),
  requestType: EDIT_DEPOSIT_GEOLOGIC_AGE_REQUEST,
  successType: EDIT_DEPOSIT_GEOLOGIC_AGE_SUCCESS,
  failureType: EDIT_DEPOSIT_GEOLOGIC_AGE_FAILURE,
});

export const depositEditSagas = [
  getDepositSaga,
  createDepositSaga,
  updateDepositSaga,
  getTsunamiSaga,
  searchTsunamisSaga,
  getReferencesSaga,
  searchReferencesSaga,
  getCountriesSaga,
  getLocationNameSaga,
  getPublicationsSaga,
  getEventSaga,
  getBodiesOfWaterSaga,
  getGeologicAgeSaga,
];
